"use client"

import { AnimatePresence, motion } from "framer-motion"

type Props = {
  title: string
}


const TITLE_ANIMATION = {

  initial:{
    opacity:0,
    y:6,
    filter:"blur(4px)",
  },

  animate:{
    opacity:1,
    y:0,
    filter:"blur(0px)",

    transition:{
      duration:0.5, /* 0.35 */
      ease: [
        0.16,
        1,
        0.3,
        1,
      ] as const,
    },
  },

  exit:{
    opacity:0,
    y:-4,
    filter:"blur(3px)",

    transition:{
      duration:0.2,
    },
  },

}



export function TopnavRouteTitle({
  title
}:Props){

  return (

    <div
      className="
        absolute
        left-1/2
        -translate-x-1/2
        flex
        items-center
        justify-center
        pointer-events-none
      "
    >

      <AnimatePresence mode="wait">

        <motion.h1

          key={title}

          variants={TITLE_ANIMATION}

          initial="initial"

          animate="animate"

          exit="exit"

          className="
            text-sm
            font-semibold
            text-[var(--primary-color)]
            whitespace-nowrap
            text-center
          "

        >

          {title}

        </motion.h1>


      </AnimatePresence>

    </div>

  )

}

/* type Props = {
  title: string
}

export function TopnavRouteTitle({
  title,
}: Props) {
  return (
    <div
      className="
        absolute
        left-1/2
        -translate-x-1/2
        pointer-events-none
      "
    >
      <span
        className="
          text-sm
          font-bold
          tracking-wide
          opacity-90 text-[var(--primary-color)]
        "
      >
        {title}
      </span>
    </div>
  )
} */